/* eslint-disable @typescript-eslint/no-explicit-any */

export const PasskeyPopupItem = ({ item, index }: any) => {
  const parts = item.title.split(/\{(.*?)\}/g);

  return (
    <div>
      <span className="font-bold pr-2">0{index + 1}.</span>
      {parts.map((part: string, index: number) =>
        item?.attr?.[part] ? (
          <>
            <a
              key={index}
              href={item?.attr?.[part]}
              className="font-bold text-primary"
              target="_blank"
            >
              {item?.attr?.[part]}
            </a>
          </>
        ) : (
          part
        )
      )}
      <div className="border rounded-md p-2 mt-5">
        <img src={item.image} className="h-[520px] w-full object-contain" />
      </div>
    </div>
  );
};
